export const CSS = {
  textContainer: "text-container",
  fullName: "full-name",
  username: "username",
  button: "button",
};
